// LinkedIn Insight Tag is production-only, like PostHog and the Meta Pixel.
const enabled = import.meta.env.VITE_ENVIRONMENT === 'production'

type LintrkFn = (action: string, data?: unknown) => void

type Lintrk = LintrkFn & {
  q: [string, unknown][]
}

declare global {
  // Window augmentation requires declaration merging, which only an interface does.
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Window {
    _linkedin_data_partner_ids?: string[]
    lintrk?: Lintrk
  }
}

const SCRIPT_SRC = 'https://snap.licdn.com/li.lms-analytics/insight.min.js'

export const initLinkedInInsight = () => {
  const partnerId = import.meta.env.VITE_LINKEDIN_PARTNER_ID

  if (!enabled || !partnerId || window.lintrk) return

  // insight.min.js reads the partner ids off window, then drains the `q` queue that
  // the stub below fills while the real script is still loading.
  window._linkedin_data_partner_ids ??= []
  window._linkedin_data_partner_ids.push(partnerId)

  const lintrk = ((action: string, data?: unknown) => {
    lintrk.q.push([action, data])
  }) as Lintrk

  lintrk.q = []
  window.lintrk = lintrk

  const script = document.createElement('script')
  script.async = true
  script.src = SCRIPT_SRC
  document.head.appendChild(script)
}

// Conversions are reported with `window.lintrk('track', { conversion_id })`. The
// Insight Tag follows History API navigations itself, so SPA page views need no
// per-route call the way the Meta Pixel does.
export const trackLinkedInConversion = (conversionId: number) => {
  if (!enabled) return

  window.lintrk?.('track', { conversion_id: conversionId })
}
